import { TranslationFunctionType } from '@/common/types';
import { isEmpty } from 'lodash';
import { array, boolean, lazy, mixed, number, object, string } from 'yup';

export const isValidGooglePrivateKey = (value: any) => {
  // Validate required structure
  if (
    typeof value !== 'object' ||
    !value ||
    typeof value.private_key !== 'string' ||
    typeof value.client_email !== 'string' ||
    typeof value.client_id !== 'string'
  ) {
    return false;
  }

  const privateKey = value.private_key.trim();
  if (
    !privateKey.startsWith('-----BEGIN PRIVATE KEY-----') ||
    !privateKey.endsWith('-----END PRIVATE KEY-----')
  ) {
    return false;
  }

  return true;
};

export const googleWorkspaceSchema = (
  isPrivateKeySet: boolean,
  t: TranslationFunctionType,
) =>
  object({
    clientId: number().required(t('error.requiredField')),
    clientEmail: string()
      .email(t('error.invalidEmail'))
      .required(t('error.requiredField')),
    adminEmail: string()
      .email(t('error.invalidEmail'))
      .required(t('error.requiredField')),
    privateKey: isPrivateKeySet
      ? string().nullable()
      : string().required(t('error.requiredField')),
    universeDomain: string().nullable(),
    active: boolean().default(false),
    mapping: lazy((value, context) => {
      if (!isEmpty(value) && context.parent.active) {
        const validationObject = {
          groupId: string().required(t('error.enterObjectId')),
          account: object().nullable(),
          branches: array(),
          groups: array(),
          language: string().required(t('error.requiredLanguage')),
        };
        const newEntries = Object.keys(value).reduce(
          (acc, val) => ({
            ...acc,
            [val]: object(validationObject),
          }),
          {},
        );

        return object().shape(newEntries);
      }
      return mixed();
    }),
  });
